// extracted by mini-css-extract-plugin
var _1 = "RentalPortalMatchFitCell-moduleRentalPortalMatchFitCell__afNH9";
var _2 = "RentalPortalMatchFitCell-modulebadge__o8YY_";
var _3 = "RentalPortalMatchFitCell-modulecompact__zDS1F";
var _4 = "RentalPortalMatchFitCell-modulecoverage__ZWyEj";
var _5 = "RentalPortalMatchFitCell-modulenumeral__eBezn";
var _6 = "RentalPortalMatchFitCell-modulering__eddJn RentalPortalMatchScoreRing-moduleRentalPortalMatchScoreRing__xExz4";
var _7 = "RentalPortalMatchFitCell-modulescore__pEdnn";
var _8 = "RentalPortalMatchFitCell-modulescoreOnly__qumky";
export { _1 as "RentalPortalMatchFitCell", _2 as "badge", _3 as "compact", _4 as "coverage", _5 as "numeral", _6 as "ring", _7 as "score", _8 as "scoreOnly" }
